import "./addressConfirmPlusCreatNewUser.scss";
import LocationSearchBar from "../../../commonComponents/navBar/locationSearchBar";
import "../../../commonComponents/navBar/navBar.scss";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

//! defaultValue={1}

function AddressConfirmPlusCreatNewUser() {
  const userDataFromReducer = useSelector((state) => state.userReducer);
  const [response, setResponse] = useState(false);
  // const [errorMessagAddress, setErrorMessagAddress] = useState("");
  const navigate = useNavigate();
  const navigateToLogIn = () => {
    navigate("/logIn");
  };

  useEffect(() => {
    // Check if the page was refreshed
    const wasRefreshed = localStorage.getItem("refreshed");
    if (wasRefreshed) {
      // Clear the flag in local storage
      localStorage.removeItem("refreshed");
      // Navigate to the desired route
      navigate("/user/creatuser");
    }

    // Set the flag in local storage to detect future refreshes
    localStorage.setItem("refreshed", "true");

    // Now, you can perform other actions when the component mounts

    // Clean up the local storage flag when the component unmounts
    return () => {
      localStorage.removeItem("refreshed");
    };
  }, [navigate]);

  const sendUserStateToServer = async (e) => {
    e.preventDefault();

    await axios
      .post("https://femez.onrender.com/API/user/addUser", userDataFromReducer)
      .then((response) => {
        console.log(response.data); // the response data
        console.log(response.status); // the response status code
        console.log(response.headers); // the response headers
        console.log(response.error);
        navigateToLogIn();
      })
      .catch((error) => {
        console.log(error);
        setResponse(error);
      });
    // }
    // else {
    //   console.log("Empty properties:", emptyProperties);
    // const errorMessage = ` ${emptyProperties.join(", ")}. is required `;
    // setErrorMessagAddress(errorMessage);
    // }
  };

  return (
    <div className="addressConfirmation-container">
      <div className="addressConfirmation">
        <p>Confirm your address</p>
        <div className="location-labels">
          <label>
            <LocationSearchBar />
          </label>
        </div>
        <button onClick={sendUserStateToServer}>SignUp</button>
        {response && <div style={{ color: "red" }}>Invalid address</div>}
        {/* {emptyProperties.length !== 0 && (
          <div style={{ color: "red", padding: "0 0 0 10px" }}>
            {errorMessagAddress}
          </div>
        )} */}
      </div>
    </div>
  );
}

export default AddressConfirmPlusCreatNewUser;
